export enum SignalrMethod {
  Unsubscribe = 'Unsubscribe',
  Subscribe = 'Subscribe',
  SetUid = 'SetUid',
  GetAllOptionSymbols = 'GetAllOptionSymbols',
  Get50StockSymbols = 'Get50StockSymbols',
  GetAllStockSymbols = 'GetAllStockSymbols',
}
